import { oc } from '@orpc/contract';
import { listServiceEventsOutputSchema, updateServiceEventInputSchema } from '../schemas/history.schemas.js';
export const updateServiceEventContract = oc
    .route({
    method: 'PATCH',
    path: '/history/{id}',
    tags: ['History'],
    summary: 'Correct a historical service event',
})
    .input(updateServiceEventInputSchema)
    .output(listServiceEventsOutputSchema);
//# sourceMappingURL=update-service-event.contract.js.map